var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "02wk2n0zta",
    d: "M6.135.575v3.45c0 .318-.258.576-.576.576h-.575V2.109c0-.529-.43-.959-.958-.959H1.534V.575c0-.317.257-.575.575-.575h3.45c.318 0 .576.258.576.575zM4.6 2.11v3.45c0 .318-.258.576-.575.576H.576C.257 6.135 0 5.877 0 5.559V2.11c0-.318.258-.575.575-.575h3.45c.318 0 .576.257.576.575zm-.815.335c0-.079-.065-.144-.144-.144H.911c-.08 0-.144.065-.144.144v.623h3.02v-.623z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowRestore);
export default __webpack_public_path__ + "static/media/window-restore.5be8992968ff9e73c95aa9611d3508de.svg";
export { ForwardRef as ReactComponent };